import { useEffect } from "react";
import EnquiryForm from "@/components/EnquiryForm";
import RiskDisclosure from "@/components/RiskDisclosure";
import { Reveal, MaskReveal } from "@/components/Reveal";
import { CONTACT } from "@/data/content";

const Contact = () => {
  useEffect(() => {
    document.title = "Contact — Enquire About Courses & EnTrade | T Plus One";
  }, []);

  return (
    <main className="pt-32 lg:pt-40 pb-24 lg:pb-32" data-testid="contact-page">
      <div className="container-x grid lg:grid-cols-2 gap-14 lg:gap-20">
        <div>
          <Reveal><p className="eyebrow">Contact</p></Reveal>
          <MaskReveal as="h1" lines={["Start the conversation."]} className="mt-6 text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.08]" />
          <Reveal delay={0.2}>
            <p className="mt-8 text-base sm:text-lg text-dim leading-relaxed max-w-md">
              Enquire about TradeX, TradeFX, ExpertIN or EnTrade membership. The team responds within one business day.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <dl className="mt-12 space-y-6 max-w-sm">
              {[
                ["Email", CONTACT.email, `mailto:${CONTACT.email}`],
                ["Phone", CONTACT.phone, `tel:${CONTACT.phone.replace(/\s/g, "")}`],
                ["Classroom", CONTACT.address, null],
              ].map(([k, v, href]) => (
                <div key={k} className="flex justify-between gap-6 border-b border-line pb-5">
                  <dt className="eyebrow pt-1">{k}</dt>
                  <dd className="text-sm font-medium text-right max-w-[240px] leading-relaxed">
                    {href ? (
                      <a href={href} data-testid={`contact-${k.toLowerCase()}-link`} className="hover:text-pine transition-colors">{v}</a>
                    ) : v}
                  </dd>
                </div>
              ))}
            </dl>
          </Reveal>
          <Reveal delay={0.4} className="mt-12">
            <RiskDisclosure />
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div className="rounded-sm border border-line bg-white p-8 lg:p-10 lg:sticky lg:top-28">
            <p className="eyebrow mb-8">Enquiry Form</p>
            <EnquiryForm />
          </div>
        </Reveal>
      </div>
    </main>
  );
};

export default Contact;
